async function navsidebar(role){
    switch(role) {
        case 'BPM':{
            const menuarray = [
                { title: 'utama', icon: 'mdi-view-dashboard', url: `paparanutama`},
            ]
            return menuarray
        }
        case 'PP':{
            const menuarray = [
                {
                    to     : 'paparanutama',
                    icon   : 'mdi-home',
                    text   : 'Paparan Utama',
                },
                {
                    icon     : 'mdi-account-multiple-plus',
                    text     : 'Modul Pengurusan Pengguna',
                    subLinks : [
                        {
                            text : 'Pengguna',
                            to    : 'penggunasistem',
                            icon : 'mdi-account-multiple-plus',
                        },
                        { 
                            text: 'Tetapan Penyelia', 
                            icon: 'mdi-account-arrow-right', 
                            to: `tetapkanpenyeliaprosesanoperasi`
                        },
                        // { 
                        //     text: 'Maklumat Daftar Responden', 
                        //     icon: 'mdi-account-arrow-right', 
                        //     to: `hiesidresponden`
                        // },
                    ]
                },
                {
                    icon     : 'mdi-lead-pencil',
                    text     : 'Daftar',
                    subLinks : [
                        // {
                        //     text : 'Pusingan',
                        //     to    : 'pusingan',
                        //     icon : 'mdi-timetable',
                        // },
                        {
                            text : 'Batch',
                            to    : 'batch',
                            icon : 'mdi-text-box-multiple-outline',
                        },
                        {
                            text : 'HID',
                            to    : 'HID',
                            icon : 'mdi-pencil-box',
                        },
                      
                    ]
                },
                {
                    icon     : 'mdi-database-plus',
                    text     : 'Modul Tangkapan Data',
                    subLinks : [
                        {
                            text : 'HIS',
                            to    : 'ringkasanMaklumatIR',
                            icon : 'mdi-table',
                        },
                        {
                            text : 'HES',
                            to    : 'BLK3PreCode/:hid?',
                            icon : 'mdi-table',
                        },
                        {
                            text : 'Ringkasan JRB',
                            to    : 'summaryJRB',
                            icon : 'mdi-file-table-box-multiple',
                        },
                    ]
                },
                {
                    icon     : 'mdi-tablet-dashboard',
                    text     : 'Modul Pamer Data',
                    subLinks : [
                        {
                            text : 'Pamer Data Hies',
                            to    : 'pamerdatahies',
                            icon : 'mdi-file-table-box-multiple',
                        },
                        
                    ]
                },
                {
                    to     : 'validasi',
                    icon   : 'mdi-shield-check',
                    text   : 'Modul Validasi',
                },
                {
                    icon     : 'mdi-table-large',
                    text     : 'Jadual Awalan',
                    subLinks : [
                        {
                            text : 'Kadar Respon',
                            to    : 'kadarrespon',
                            icon : 'mdi-chart-donut-variant',
                        },
                        {
                            text : 'Pendapatan Purata',
                            to    : 'pendapatanpurata',
                            icon : 'mdi-chart-bar',
                        },
                        {
                            text : 'Pendapatan Penengah',
                            to    : 'penengah',
                            icon : 'mdi-chart-bar-stacked',
                        },
                        {
                            text : 'Kaum & Strata',
                            to    : 'kaumxstrata',
                            icon : 'mdi-chart-gantt',
                        },
                        {
                            text : 'Daerah Pentadbiran & Strata',
                            to    : 'daerahxstrata',
                            icon : 'mdi-chart-bubble',
                        },
                        
                    ]
                },
                // {
                //     icon     : 'mdi-chart-line-stacked',
                //     text     : 'Julat Harga',
                //     subLinks : [
                //         {
                //             text : 'Julat Harga',
                //             to    : 'julatHarga',
                //             icon : 'mdi-chart-timeline',
                //         },
                //         {
                //             text : 'Min/Max',
                //             to    : 'julatHargaMinMax',
                //             icon : 'mdi-plus-minus-variant',
                //         },
                //     ]
                // },
                // {
                //     to     : '/tournaments',
                //     icon   : 'mdi-trophy',
                //     text   : 'Tournaments',
                // },
                // { title: 'utama', icon: 'mdi-home', url: `paparanutama`},
                // { title: 'penggunasistem', icon: 'mdi-account-multiple-plus', url: `penggunasistem`},
                // { title: 'pusingan', icon: 'mdi-timetable', url: `pusingan`},
                // { title: 'tetapkanpppo', icon: 'mdi-account-arrow-right', url: `tetapkanpenyeliaprosesanoperasi`},
                // { title: 'daftarbatch', icon: 'mdi-text-box-multiple-outline', url: `batch` },
                // { title: 'daftarhid', icon: 'mdi-pencil-box', url: `HID` },
                // { title: 'ringkasanir', icon: 'mdi-table', url: `ringkasanMaklumatIR`},
                // { title: 'ringkasanjrb', icon: 'mdi-file-table-box-multiple', url: `ringkasanJRB` },
                // },
                // { title: 'jadualfilter', icon: 'mdi-table', url: `tablefilter`},
                // { title: 'borang', icon: 'mdi-help-box', url: `form` },
                // { title: 'Photos1', icon: 'mdi-image', url: 'testpage'},
            ]
            return menuarray
        }
        case 'SMD':{
            const menuarray = [
                { title: 'utama', icon: 'mdi-view-dashboard', url: `paparanutama`},
            ]
            return menuarray
        }
        case 'PO':{
            const menuarray = [
                {
                    to     : 'paparanutama',
                    icon   : 'mdi-home',
                    text   : 'Paparan Utama',
                },
                {
                    icon     : 'mdi-account-multiple-plus',
                    text     : 'Modul Pengurusan Pengguna',
                    subLinks : [
                        {
                            text : 'Pengguna',
                            to    : 'penggunasistem',
                            icon : 'mdi-account-multiple-plus',
                        },
                        { 
                            text: 'Tetapan PO/PP', 
                            icon: 'mdi-account-arrow-right', 
                            to: `tetapkanpenyeliaprosesanoperasi`
                        },
                        // { 
                        //     text: 'Maklumat Daftar Responden', 
                        //     icon: 'mdi-account-arrow-right', 
                        //     to: `hiesidresponden`
                        // },
                    ]
                },
                {
                    icon     : 'mdi-timetable',
                    text     : 'Daftar',
                    subLinks : [
                        // {
                        //     text : 'Pusingan',
                        //     to    : 'pusingan',
                        //     icon : 'mdi-timetable',
                        // },
                        {
                            text : 'Batch',
                            to    : 'batch',
                            icon : 'mdi-text-box-multiple-outline',
                        },
                        {
                            text : 'HID',
                            to    : 'HID',
                            icon : 'mdi-pencil-box',
                        },
                      
                    ]
                },
                {
                    icon     : 'mdi-account-multiple-plus',
                    text     : 'Modul Tangkapan Data',
                    subLinks : [
                        {
                            text : 'HIS',
                            to    : 'ringkasanMaklumatIR',
                            icon : 'mdi-table',
                        },
                        {
                            text : 'HES',
                            to    : 'BLK3PreCode/:hid?',
                            icon : 'mdi-table',
                        },
                        {
                            text : 'Ringkasan JRB',
                            to    : 'summaryJRB',
                            icon : 'mdi-file-table-box-multiple',
                        },
                    ]
                },
                {
                    icon     : 'mdi-tablet-dashboard',
                    text     : 'Modul Pamer Data',
                    subLinks : [
                        {
                            text : 'Pamer Data Hies',
                            to    : 'pamerdatahies',
                            icon : 'mdi-file-table-box-multiple',
                        },
                    ]
                },
                {
                    icon     : 'mdi-table-large',
                    text     : 'Jadual Awalan',
                    subLinks : [
                        {
                            text : 'Kadar Respon',
                            to    : 'kadarrespon',
                            icon : 'mdi-chart-donut-variant',
                        },
                        {
                            text : 'Pendapatan Purata',
                            to    : 'pendapatanpurata',
                            icon : 'mdi-chart-bar',
                        },
                        {
                            text : 'Pendapatan Penengah',
                            to    : 'penengah',
                            icon : 'mdi-chart-bar-stacked',
                        },
                        {
                            text : 'Kaum & Strata',
                            to    : 'kaumxstrata',
                            icon : 'mdi-chart-gantt',
                        },
                        {
                            text : 'Daerah Pentadbiran & Strata',
                            to    : 'daerahxstrata',
                            icon : 'mdi-chart-bubble',
                        },
                        
                    ]
                },
                // {
                //     icon     : 'mdi-chart-line-stacked',
                //     text     : 'Julat Harga',
                //     subLinks : [
                //         {
                //             text : 'Julat Harga',
                //             to    : 'julatHarga',
                //             icon : 'mdi-chart-timeline',
                //         },
                //         {
                //             text : 'Min/Max',
                //             to    : 'julatHargaMinMax',
                //             icon : 'mdi-plus-minus-variant',
                //         },
                //     ]
                // },
            ]
            return menuarray
        }
        case 'FE':{
            const menuarray = [
                {
                    to     : 'paparanutama',
                    icon   : 'mdi-home',
                    text   : 'Paparan Utama',
                },
                {
                    icon     : 'mdi-timetable',
                    text     : 'Daftar',
                    subLinks : [
                        {
                            text : 'Batch',
                            to    : 'batch',
                            icon : 'mdi-text-box-multiple-outline',
                        },
                        {
                            text : 'HID',
                            to    : 'HID',
                            icon : 'mdi-pencil-box',
                        },
                      
                    ]
                },
                {
                    icon     : 'mdi-database-plus',
                    text     : 'Modul Tangkapan Data',
                    subLinks : [
                        {
                            text : 'HIS',
                            to    : 'ringkasanMaklumatIR',
                            icon : 'mdi-table',
                        },
                        {
                            text : 'HES',
                            to    : 'BLK3PreCode/:hid?',
                            icon : 'mdi-table',
                        },
                        {
                            text : 'Ringkasan JRB',
                            to    : 'ringkasanJRB',
                            icon : 'mdi-file-table-box-multiple',
                        },
                    ]
                },
                {
                    to     : 'validasi',
                    icon   : 'mdi-shield-check',
                    text   : 'Modul Validasi',
                },
            ]
            return menuarray
        }
        case 'RESPONDENT':{
            const menuarray = [
                { title: 'utama', icon: 'mdi-view-dashboard', url: `paparanutama`},
            ]
            return menuarray
        }
        case 'PUBLIC':{
            const menuarray = [
                { title: 'utama', icon: 'mdi-view-dashboard', url: `paparanutama`},
            ]
            return menuarray
        }
        case 'ADMIN':{
            const menuarray = [
                {
                    to     : 'paparanutama',
                    icon   : 'mdi-home',
                    text   : 'Paparan Utama',
                },
                {
                    icon     : 'mdi-account-multiple-plus',
                    text     : 'Modul Pengurusan Pengguna',
                    subLinks : [
                        {
                            text : 'Pengguna',
                            to    : 'penggunasistem',
                            icon : 'mdi-account-multiple-plus',
                        },
                        { 
                            text: 'Tetapan Penyelia', 
                            icon: 'mdi-account-arrow-right', 
                            to: `tetapkanpenyeliaprosesanoperasi`
                        },
                        // { 
                        //     text: 'Maklumat daftar responden', 
                        //     icon: 'mdi-account-arrow-right', 
                        //     to: `hiesidresponden`
                        // },
                    ]
                },
                {
                    icon     : 'mdi-lead-pencil',
                    text     : 'Pendaftaran',
                    subLinks : [
                        {
                            text : 'Pusingan',
                            to    : 'pusingan',
                            icon : 'mdi-timetable',
                        },
                        {
                            text : 'Batch',
                            to    : 'batch',
                            icon : 'mdi-text-box-multiple-outline',
                        },
                        {
                            text : 'HID',
                            to    : 'HID',
                            icon : 'mdi-pencil-box',
                        },
                        {
                            text : 'BP',
                            to    : 'BP',
                            icon : 'mdi-file-document-edit-outline',
                        },

                        {
                            text : 'Kod Item 3',
                            to    : 'koditem3',
                            icon : 'mdi-numeric-3-box-multiple',
                        },

                         {
                            text : 'Kod Item 4a',
                            to    : 'koditem4a',
                            icon : 'mdi-numeric-4-box-multiple',
                        },
                      
                         {
                            text : 'Kod Item 4b',
                            to    : 'koditem4b',
                            icon : 'mdi-alpha-b-box',
                        },

                        {
                            text : 'Kod Item 4c',
                            to    : 'koditem4c',
                            icon : 'mdi-alpha-c-box',
                        },
                      
                    ]
                },
                {
                    icon     : 'mdi-database-plus',
                    text     : 'Modul Tangkapan Data',
                    subLinks : [
                        {
                            text : 'HIS',
                            to    : 'ringkasanMaklumatIR',
                            icon : 'mdi-table',
                        },
                        {
                            text : 'HES',
                            to    : 'BLK3PreCode/:hid?',
                            icon : 'mdi-table',
                        },
                        {
                            text : 'Ringkasan JRB',
                            to    : 'summaryJRB',
                            icon : 'mdi-file-table-box-multiple',
                        },
                    ]
                },
                {
                    icon     : 'mdi-tablet-dashboard',
                    text     : 'Modul Pamer Data',
                    subLinks : [
                        {
                            text : 'Pamer Data Hies',
                            to    : 'pamerdatahies',
                            icon : 'mdi-file-table-box-multiple',
                        },

                        {
                            text : 'Pamer Data Visual',
                            to    : 'pamerdatavisual',
                            icon : 'mdi-file-table-box-multiple',
                        },
                        
                    ]
                },
                
                {
                    icon     : 'mdi-table-large',
                    text     : 'Jadual Awalan',
                    subLinks : [
                        {
                            text : 'Kadar Respon',
                            to    : 'kadarrespon',
                            icon : 'mdi-chart-donut-variant',
                        },
                        {
                            text : 'Pendapatan Purata',
                            to    : 'pendapatanpurata',
                            icon : 'mdi-chart-bar',
                        },
                        {
                            text : 'Pendapatan Penengah',
                            to    : 'penengah',
                            icon : 'mdi-chart-bar-stacked',
                        },
                        {
                            text : 'Kaum & Strata',
                            to    : 'kaumxstrata',
                            icon : 'mdi-chart-gantt',
                        },
                        {
                            text : 'Daerah Pentadbiran & Strata',
                            to    : 'daerahxstrata',
                            icon : 'mdi-chart-bubble',
                        },
                        
                    ]
                },
                {
                    icon     : 'mdi-chart-line-stacked',
                    text     : 'Julat Harga',
                    subLinks : [
                        {
                            text : 'Julat Harga',
                            to    : 'julatHarga',
                            icon : 'mdi-chart-timeline',
                        },
                        {
                            text : 'Min/Max',
                            to    : 'julatHargaMinMax',
                            icon : 'mdi-plus-minus-variant',
                        },
                    ]
                },
                {
                    to     : 'validasi',
                    icon   : 'mdi-shield-check',
                    text   : 'Modul Validasi',
                },
                {
                    to     : 'wajaran',
                    icon   : 'mdi-chart-timeline-variant-shimmer',
                    text   : 'Wajaran',
                },
                {
                    to     : 'pivot',
                    icon   : 'mdi-home',
                    text   : 'Pivot',
                },

                
            ]
            return menuarray
        }
        default: {
            alert('Tiada Role')
            const menuarray = [
            ]
            return menuarray
            
        }
    }
}

export default navsidebar